import CacheUpdateNotice from "./CacheUpdateNotice";

const CacheUpdateGreenLine = ({visible = false, ...props}) => {
    if (!visible) return null;
    return <CacheUpdateNotice mode="green_line" {...props} />;
};

export default CacheUpdateGreenLine;
